// 路由配置
const config={
	// 白名单，不需要权限的页面
	whiteList:['/Login','/forgetPassword'],
	// 默认展开的菜单目录
	defaultOpen:['/setting'],
}
export default config